import React from "react";
import TabsSection from "../components/TabSection";
import { Link } from "react-router-dom"; // Or 'next/link' if Next.js

const sectionData = [
  {
    title: "Farmer",
    leftImg: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745281942/image_ejmnax.png",
    icons: [
      { src: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359425/image_gfifhe.png", label: "Market Information" },
      { src: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359391/image-1_bybda7.png", label: "Farming Guidance" },
      { src: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359425/image_gfifhe.png", label: "Financial Resources" },
    ],
    benefits: [
      {
        heading: "Access to Real-Time Market Information",
        paragraph: "FarmNet provides farmers with up-to-date market prices for various crops, enabling them to make informed decisions about when and where to sell their produce for maximum profit."
      },
      {
        heading: "Personalized Farming Guidance",
        paragraph: "The app offers tailored advice on crop management, pest control, and disease prevention, helping farmers optimize their practices and improve yields."
      },
      {
        heading: "Facilitated Access to Financial Resources",
        paragraph: "FarmNet connects farmers with potential investors and financial institutions, streamlining access to funding for purchasing inputs, equipment, or expanding operations."
      }
    ],
    link: "/solutions1"
  },
  {
    title: "Service Provider",
    leftImg: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745281649/image-1_revhhh.png",
    icons: [
      { src: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359392/image-2_hl2wbv.png", label: "Access Farmer Network" },
      { src: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359392/image-3_a0viqj.png", label: "Service Delivery" },
      { src: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359425/image_gfifhe.png", label: "Transactions Records" },
    ],
    benefits: [
      {
        heading: "Direct Access to a Verified Farmer Network",
        paragraph: "Service providers can connect directly with thousands of registered and active farmers. This helps them expand their customer base and reduce the cost of outreach and marketing."
      },
      {
        heading: "Data-Driven Insights for Better Service Delivery",
        paragraph: "The app collects valuable data on farmers' needs, locations, crop types, and farming cycles—enabling service providers to tailor their products and services more effectively and increase relevance."
      },
      {
        heading: "Efficient Transactions and Digital Records",
        paragraph: "FarmNet facilitates smoother transactions, including input deliveries, payment tracking, and service usage, all in one platform—reducing paperwork and improving accountability."
      }
    ],
    link: "/solutions2"
  },
  {
    title: "Offtake Partner",
    leftImg: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745281651/image-2_hblwc2.png",
    icons: [
      { src: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359392/image-5_mujusa.png", label: "Traceable Supply Chains" },
      { src: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359392/image-6_yhlefd.png", label: "Procurement and Logistics" },
      { src: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359393/image-7_b3gibg.png", label: "Production Forecasts" },
    ],
    benefits: [
      {
        heading: "Reliable Access to Traceable Supply Chains",
        paragraph: "Offtakers can source produce directly from verified farmers, ensuring transparency, traceability, and consistency in quality and quantity."
      },
      {
        heading: "Streamlined Procurement and Logistics",
        paragraph: "The app helps coordinate harvesting, collection points, and deliveries—making it easier for offtakers to plan, reduce delays, and lower operational costs."
      },
      {
        heading: "Real-Time Production Forecasts",
        paragraph: "With real-time farm data, offtakers can predict harvest volumes and timelines, allowing for better planning, inventory control, and market alignment."
      }
    ],
    link: "/solutions3"
  },
  {
    title: "Development Partner",
    leftImg: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745281936/image-3_fikesp.png",
    icons: [
      { src: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359408/image-14_cxa6ui.png", label: "Actionable Data" },
      { src: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359393/image-9_sbdveb.png", label: "Outreach and Impact" },
      { src: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359393/image-9_sbdveb.png", label: "Transparency and Accountability" },
    ],
    benefits: [
      {
        heading: "Access to Real-Time, Actionable Data",
        paragraph: "Development partners can monitor farming activities, production levels, and impact metrics in real-time—enabling evidence-based decision-making and effective program targeting."
      },
      {
        heading: "Scalable Outreach and Impact",
        paragraph: "FarmNet provides a digital platform to efficiently reach thousands of smallholder farmers, allowing partners to scale interventions, deliver training content, and track adoption at low cost."
      },
      {
        heading: "Improved Transparency and Accountability",
        paragraph: "With digital records of services delivered, farmer interactions, and input usage, development partners can ensure transparency, enhance reporting accuracy, and demonstrate measurable impact to stakeholders."
      }
    ],
    link: "/solutions4"
  },
  {
    title: "Education",
    leftImg: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745281942/image-4_qnctse.png",
    icons: [
      { src: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359394/image-11_lrqjla.png", label: "Learning Opportunities" },
      { src: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359407/image-12_kv9bt4.png", label: "Data for Research" },
      { src: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359407/image-13_h3kxda.png", label: "Knowledge Sharing" },
    ],
    benefits: [
      {
        heading: "Field-Based Learning Opportunities",
        paragraph: "Educational institutions can use FarmNet to connect students with real farming communities, providing practical, on-the-ground experience through data, case studies, and internships."
      },
      {
        heading: "Access to Agricultural Data for Research",
        paragraph: "Institutions benefit from real-time, localized farm data (e.g. crop yields, farming practices, input usage), which supports research, curriculum development, and evidence-based learning."
      },
      {
        heading: "Outreach and Knowledge Sharing",
        paragraph: "Through FarmNet, institutions can disseminate training materials, extension advice, and innovations directly to farmers—expanding the impact of their research and community engagement."
      }
    ],
    link: "/solutions5"
  },
  {
    title: "Institution",
    leftImg: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745281937/image-5_xtxfry.png",
    icons: [
      { src: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359408/image-14_cxa6ui.png", label: "Ground-Level Data" },
      { src: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359408/image-15_f8ob9q.png", label: "Validation & Field Testing" },
      { src: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359408/image-16_gytgsu.png", label: "Collaboration & Knowledge" },
    ],
    benefits: [
      {
        heading: "Access to Real-Time, Ground-Level Data",
        paragraph: "FarmNet provides researchers with up-to-date, location-specific data on farming practices, crop performance, climate trends, and input use—supporting accurate, data-driven research."
      },
      {
        heading: "Enhanced Research Validation & Field Testing",
        paragraph: "Institutions can pilot innovations, test new technologies, and validate research findings directly with a diverse network of farmers—enabling practical, real-world application."
      },
      {
        heading: "Collaboration & Knowledge Exchange",
        paragraph: "The app creates opportunities for collaboration between researchers, farmers, and agri-stakeholders, allowing for two-way knowledge transfer and faster adoption of proven solutions."
      }
    ],
    link: "/solutions6"
  },
  {
    title: "Community",
    leftImg: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745281942/image-6_fi0j3e.png",
    icons: [
      { src: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359415/image-17_h2ycbh.png", label: "Resources and Services" },
      { src: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359415/image-18_svxkvg.png", label: "Networks and Collaboration" },
      { src: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359415/image-19_xus2dg.png", label: "Information and Training" },
    ],
    benefits: [
      {
        heading: "Improved Access to Resources and Services",
        paragraph: "FarmNet connects communities to quality inputs, extension services, financial tools, and reliable markets—helping farmers increase productivity and income."
      },
      {
        heading: "Stronger Community Networks and Collaboration",
        paragraph: "The app helps build connected farmer groups and cooperatives, encouraging knowledge sharing, group buying, and collective selling, which boosts bargaining power and community resilience."
      },
      {
        heading: "Access to Information and Training",
        paragraph: "Farming communities benefit from localized advisory content, weather alerts, and practical training—empowering them to make better farming decisions and adapt to challenges like climate change."
      }
    ],
    link: "/solutions7"
  },
  {
    title: "Investor",
    leftImg: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745578265/image_33_f2pos8.png",
    icons: [
      { src: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359416/image-20_yayddy.png", label: "Transparency & Monitoring" },
      { src: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359416/image-21_pkyis8.png", label: "Risk Reduction" },
      { src: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359416/image-22_jiwvna.png", label: "ROI" },
    ],
    benefits: [
      {
        heading: "Transparency and Real-Time Monitoring",
        paragraph: "FarmNet provides real-time data on farm activities, input usage, and crop progress—giving investors full visibility and traceability into how their capital is being used."
      },
      {
        heading: "Risk Reduction and Better Decision-Making",
        paragraph: "Access to data on weather, pest outbreaks, market trends, and farmer performance helps investors assess risks early and make informed investment decisions."
      },
      {
        heading: "Improved ROI through Scalable Farm Support",
        paragraph: "By connecting farmers with expert advice, quality inputs, and markets, FarmNet helps boost productivity and profitability—leading to stronger returns on agricultural investments."
      }
    ],
    link: "/solutions8"
  },
  {
    title: "Input Suppliers",
    leftImg: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745281940/image-8_u6kbyr.png",
    icons: [
      { src: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359425/image-23_cwkvtm.png", label: "Farmer Network" },
      { src: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359425/image-24_po2psa.png", label: "Farm Data" },
      { src: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359392/image-6_yhlefd.png", label: "Logistics" },
    ],
    benefits: [
      {
        heading: "Direct Access to a Large Farmer Network",
        paragraph: "Suppliers can market and distribute their products directly to a wide base of verified farmers, reducing reliance on middlemen and expanding their customer reach."
      },
      {
        heading: "Targeted Marketing Through Farm Data",
        paragraph: "With access to crop-specific and location-based data, suppliers can tailor promotions and offer relevant products to farmers at the right time in the growing season."
      },
      {
        heading: "Digital Orders and Streamlined Logistics",
        paragraph: "FarmNet enables digital ordering, delivery coordination, and inventory tracking, making it easier and more efficient to manage sales and distribution in rural areas."
      }
    ],
    link: "/solutions9"
  }
];



const Solutions = () => {
  return (
    <div className="bg-white md:pt-5 mt-2 pb-2 md:pb-5 pt-3">
    <div className="md:px-20 px-4">
      <h1 className="text-[14px] md:text-[36px] font-bold md:mt-3 text-[#FDBD26]">Solutions</h1>
      <h1 className="text-[12px] md:text-[36px] font-normal md:mb-4 mb-2 mt-2 text-black">
        What are the solutions and benefits that farmers get from Farmnet App
      </h1>
  
      {sectionData.map((item, index) => (
        <div key={index}>
          <Link to={item.link}>
            <h1 className="text-[14px] md:text-[36px] font-bold md:mt-3 mt-1 text-black mb-2">{item.title}</h1>
  
            <div className="flex  md:flex-nowrap h-[140px] w-full md:h-auto rounded-[5px] overflow-hidden">
              {/* Left Image */}
              <img
                src={item.leftImg}
                alt="Left"
                className="w-[50%] md:w-[50%] h-[140px] md:h-[400px] object-cover rounded-t-[5px] md:rounded-tr-none md:rounded-tl-[5px] md:rounded-bl-[5px]"
              />
  
              {/* Right Section */}
              <div className="w-full md:w-[50%]  bg-[#F3F5F5] md:p-0 p-3 md:pt-4 md:px-8 flex flex-col justify-between rounded-b-[5px] md:rounded-bl-none md:rounded-tr-[5px] md:rounded-br-[5px]">
                {/* Icon Row */}
                <div className="flex md:space-x-32 space-x-4 flex-unwrap justify-start">
                  {item.icons.map((icon, i) => (
                    <div key={i} className="flex flex-col items-center mr-1 mb-2">
                      <img
                        src={icon.src}
                        alt={`Icon ${i + 1}`}
                        className="lg:w-[40px] lg:h-[40px] xl:w-[70px] xl:h-[70px] w-[10px] h-[10px]"
                      />
                      <h2 className="font-inter font-normal md:text-[14px] lg:text-[14px] text-[4px] mt-1 text-center leading-tight">
                        {icon.label}
                      </h2>
                    </div>
                  ))}
                </div>
  
                {/* Benefit Texts */}
                <div className="space-y-0 md:-mt-0 -mt-3">
                  <h1 className="md:text-[20px] text-[8px] font-bold">Benefits</h1>
                  {item.benefits.map((benefit, i) => (
                    <div key={i}>
                      <h3 className="font-bold text-[4px] md:text-[13px] text-black">{benefit.heading}</h3>
                      <p className="text-[4px] md:text-[13px] text-black leading-snug my-[2px]">{benefit.paragraph}</p>
                    </div>
                  ))}
                </div>
  
                {/* Arrow Icon */}
                <div className="flex justify-end -mt-10">
                  <img
                    src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744400431/Expand_right_dhyfzo.png"
                    alt="Arrow Icon"
                    className="md:w-[36px] md:h-[33px] w-[10px] h-[10px]"
                  />
                </div>
              </div>
            </div>
          </Link>
        </div>
      ))}
    </div>
  
    {/* App Download Section */}
    <div className="md:px-20 px-4">
      <h1 className="text-[18px] md:text-[32px] font-bold mt-10 mb-4 text-black">Download App</h1>
      <div className="flex sm:flex-row sm:space-x-10 space-x-5  sm:space-y-0 items-center">
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744414874/image_903_oqescj.png"
          alt="App Store"
          className="h-[30px] md:h-[75px] object-contain"
        />
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744414874/image_scynki.png"
          alt="Google Play"
          className="h-[30px] md:h-[75px] object-contain"
        />
      </div>
    </div>
    <div className="md:h-8 h-3"></div>
  </div>
  
  );
};

export default Solutions;
